import { Capacitor } from "@capacitor/core";

// Puzzly si usa dalle app (#74): il web apre solo i puzzle ricevuti. Pro si
// compra dentro l'app, dagli store.
export function isNativeApp() {
  return Capacitor.isNativePlatform();
}
